import { render, staticRenderFns } from "./PagarBarbeiroForm.vue?vue&type=template&id=f0cc0fb8&scoped=true&"
import script from "./PagarBarbeiroForm.vue?vue&type=script&lang=js&"
export * from "./PagarBarbeiroForm.vue?vue&type=script&lang=js&"
import style0 from "./PagarBarbeiroForm.vue?vue&type=style&index=0&id=f0cc0fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cc0fb8",
  null
  
)

export default component.exports